// Detekce embedded versus standalone režimu shellu

import { useSyncExternalStore } from 'react';

/** Provozní režim shellu */
export type ShellMode = 'embedded' | 'standalone';

/**
 * Zjistí, zda je aplikace renderována uvnitř iframe.
 * Čistě klientská detekce bez host override kontraktu.
 */
function detectShellMode(): ShellMode {
  try {
    return window.self !== window.top ? 'embedded' : 'standalone';
  } catch {
    // Pokud přístup k window.top selže (cross-origin iframe), považujeme za embedded
    return 'embedded';
  }
}

// Režim je stabilní po celou dobu životnosti stránky – detekce proběhne jednou
const cachedMode = detectShellMode();

function subscribe(_onStoreChange: () => void): () => void {
  // Shell mode se za runtime nemění – subscribe je no-op
  return () => {};
}

function getSnapshot(): ShellMode {
  return cachedMode;
}

function getServerSnapshot(): ShellMode {
  return 'standalone';
}

/**
 * Hook pro přístup k shell mode.
 * Vrací 'embedded' pokud je stránka v iframe, jinak 'standalone'.
 */
export function useShellMode(): ShellMode {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
